import { useTranslation } from "react-i18next";
import { Button } from "@/components/ui/button";
import { Plus } from "lucide-react";

interface TasksActionsProps {
  onCreateTask: () => void;
}

export const TasksActions = ({ onCreateTask }: TasksActionsProps) => {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <Button onClick={onCreateTask}>
        <Plus className="h-4 w-4 mr-2" />
        {t("tasks.form.create", "Create Task")}
      </Button>
    </div>
  );
};
